export default __webpack_public_path__ + "static/media/icon-calendar.6e6503c9.svg";